module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flag-2fe41f128623199c8388d77dfc4cff4e.svg";